import { Component, Input, Type } from "@angular/core";
import { MdDialog, MdDialogRef } from "@angular/material";
import { PageLayoutRevisionComponent } from "../revision-changelog/revision.component";
import { PageLayoutProductReleaseComponent } from "../add-edit-productrelease/addproductrelease.component";
import { Router } from "@angular/router";
import { tap, catchError, take } from 'rxjs/operators';
import { Subscription } from "rxjs/Subscription";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import { UserService } from "../../services/UserService";
import { AdalService } from "../../shared/adal.service";
import { PagerService } from "../../services/PagerService";
import { PageLayoutRevertReleaseComponent } from "../Revert-Release/revertrelease.component";
import { PageLayoutRevisionHistoryComponent } from "../revision-history/revisionhistory.component";
import { PageLayoutConfirmDialogComponent } from "../confirm-dialog/confirmdialog.component";
import { PageLayoutAllChangeLog } from "../view-product-changelog/viewallchangelog.component";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import { ProductReleaseStatus } from "../../interfaces/ProductReleaseStatusEnum.model";
import { HttpEventType } from "@angular/common/http";
import swal from "sweetalert2";
import { ActivateReleaseComponent } from "../activate-release/activateRelease.component";
import { ChangeReleaseTypeComponent } from "../change-release-type/change-release-type.component";
import { PilotCustomSupportedProductCodes, PilotCustomSupportedSubTypes, PilotCustomSupportedVariants } from "../../interfaces/PilotCustomReleaseProducts";
import { of } from "rxjs/observable/of";
import { forkJoin } from "rxjs/observable/forkJoin";
import { Observable } from "rxjs";
@Component({
  selector: "my-page-layout-with-product-release-tab-list",
  styles: [require('./product-release-tab-list.component.css')],
  template: require('./product-release-tab-list.component.html'),
})
export class PageLayoutProductReleaseTabListComponent {
  private sub: Subscription;
  releaseData;
  ProductId;
  errorMessage: string;
  ProductCode: number;
  ProductReleaseId: number;
  IsAdd = false;
  IsEdit = false;
  IsProductionRights = false;
  Title: string = "";
  allItems: any;
  IsApprove = false;
  IsReject = false;
  IsAllowedToAdd = false;
  pager: any = {};
  pagedItems: any[];
  IsShowDeleted: boolean = false;
  ProductCodePanelVisble = [14, 89];
  IsProductCodeVisble: boolean;
  IsValid: boolean = false;
  public ProductReleaseStatus = ProductReleaseStatus;
  @Input() SubProductName;
  @Input() ProductName;
  @Input() Code;
  @Input() SubType;
  @Input() Id;
  @Input() ParentProductId;
  @Input() TabOrder;
  @Input() Variant;

  constructor(
    public dialog: MdDialog,
    private router: Router,
    private productReleaseService: ProductReleaseService,
    private userservice: UserService,
    private pagerService: PagerService,
    private appLoaderService: AppLoaderService,
    private adalService: AdalService
  ) {
    if (!this.adalService.getCachedToken()) {
      this.router.navigate(["login"]);
    }
  }

  ngOnInit() {
    this.Title = this.SubProductName;
    this.ProductId = this.Id;
    this.ProductCode = this.Code;

    if (this.ProductCode == 13 && this.SubType == 2) {
      this.IsValid = true;
    }
    this.IsShowDeleted = false;
    this.getProductReleaseList(this.ProductId);
    this.getUserRights(
      Number(localStorage.getItem("userid")),
      this.ParentProductId
    );
  }

  showRejected(value: boolean) {
    if (value == true) {
      this.pagedItems = [];
      this.releaseData.forEach((element) => {
        this.pagedItems.push(element);
      });
    } else {
      this.pagedItems = [];
      this.releaseData.forEach((element) => {
        if (element.IsDeleted == false) {
          this.pagedItems.push(element);
        }
      });
    }
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.releaseData.length, page);
    this.pagedItems = this.releaseData.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  //#region ViewChangeLog
  openDialogWithAResult(row) {
    this.ProductReleaseId = row.ProductReleaseId;
    let dialogRef: MdDialogRef<PageLayoutRevisionComponent> = this.dialog.open(
      PageLayoutRevisionComponent,
      {
        height: "50%",
        width: "60%",
        data: {
          productReleaseId: this.ProductReleaseId,
          ProductName: this.ProductName,
          ProductReleaseNo: row.ProductReleaseNo,
          SubProductName: this.SubProductName,
        },
      }
    );
    dialogRef.afterClosed().subscribe((_result) => {
      //this.getProductReleaseList(this.ProductId);
    });
  }
  //#endregion

  //#region viewAllChangeLog
  OpenViewAllChangeLog() {
    let dialogRef: MdDialogRef<PageLayoutAllChangeLog> = this.dialog.open(
      PageLayoutAllChangeLog,
      {
        height: "50%",
        width: "60%",
        data: {
          ProductId: this.ProductId,
          ProductName: this.ProductName,
          SubProductName: this.SubProductName,
        },
      }
    );
    dialogRef.afterClosed().subscribe((_result) => {
      //this.getProductReleaseList(this.ProductId);
    });
  }
  //#endregion

  //#region Add Release
  openProductReleaseAddDialog(row) {
    if (this.IsAllowedToAdd) {
      let confirmdialog: MdDialogRef<PageLayoutConfirmDialogComponent> =
        this.dialog.open(PageLayoutConfirmDialogComponent, {
          data: { Status: "Add" },
          disableClose: true,
        });
      confirmdialog.afterClosed().subscribe((_result) => {
        this.getProductReleaseList(this.ProductId);
      });
    } else {
      let releaseDialog: MdDialogRef<PageLayoutProductReleaseComponent> =
        this.dialog.open(PageLayoutProductReleaseComponent, {
          height: "90%",
          width: "60%",
          data: {
            ProductId: this.ProductId,
            ParentProductId: this.ParentProductId,
            SubProductName: this.SubProductName,
            SubType: this.SubType,
            ProductName: this.ProductName,
            ProductCode: this.ProductCode,
            ProductReleaseId: 0,
            payload: row,
          },
          disableClose: true,
        });
      releaseDialog.afterClosed().subscribe((result) => {
        this.getProductReleaseList(this.ProductId);
        if (result != null) {
          this.SendEmail(result, ProductReleaseStatus.DevRelease);
        }
      });
    }
  }
  //#endregion

  //#region EditDialog
  openProductReleaseEditDialog(row) {
    let releaseDialog: MdDialogRef<PageLayoutProductReleaseComponent> =
      this.dialog.open(PageLayoutProductReleaseComponent, {
        height: "90%",
        width: "60%",
        data: {
          ProductId: this.ProductId,
          ParentProductId: this.ParentProductId,
          SubProductName: this.SubProductName,
          SubType: this.SubType,
          ProductName: this.ProductName,
          ProductCode: this.ProductCode,
          ProductReleaseId: row.ProductReleaseId,
          Status:row.Status,
          payload: row,
        },
        disableClose: true,
      });
    releaseDialog.afterClosed().subscribe((_result) => {
      this.getProductReleaseList(this.ProductId);
    });
  }
  //#endregion

  //#region GridData and IsAllowedtoDataAdd if any release in pending queue [ViewRelease]
  getProductReleaseList(ProductId: number) {
    // For Specific Product Visible DBVersion and Package File Upload
    this.IsProductCodeVisble = false;
    this.ProductCodePanelVisble.forEach((element) => {
      if (element == this.ProductCode) {
        this.IsProductCodeVisble = true;
      }
    });
    this.productReleaseService.getReleaseByProductId(ProductId).subscribe(
      (data) => {
        this.pagedItems = [];
        if (!data.IsError && data.DataObject != null) {
          this.releaseData = data.DataObject;
          this.releaseData.forEach((element) => {
            const customers = element.Customers ? element.Customers.map((c:any, index: number) => `${index+1}. ${c.Name}`) : [];
            const toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
            element.CustomerTooltip = toolip;
            if(this.IsShowDeleted){
              this.pagedItems.push(element);
            }
            else{
              if (element.IsDeleted == false) {
                this.pagedItems.push(element);
              }
            }
          });
          //this.setPage(this.pager.currentPage);
        } else {
          this.releaseData = null;
        }
      },
      (error) => {
        this.errorMessage = error;
      }
    );

    this.productReleaseService
      .getIsAllowedToAddReleaseByProductId(ProductId)
      .subscribe(
        (data) => {
          if (!data.IsError && data.DataObject != null) {
            this.IsAllowedToAdd = false;
          } else {
            this.IsAllowedToAdd = true;
          }
        },
        (error) => {
          this.errorMessage = error;
        }
      );
  }

  getProductReleaseList_Observable(ProductId: number) : Observable<any> {
    // 1. Run the synchronous UI checks first
    this.IsProductCodeVisble = false;
    this.ProductCodePanelVisble.forEach((element) => {
      if (element == this.ProductCode) {
        this.IsProductCodeVisble = true;
      }
    });
    const _this = this;

    // 2. Define the first API call stream with its side-effects
    const getRelease$ = this.productReleaseService.getReleaseByProductId(ProductId).pipe(
      take(1),
      tap((data) => {
        _this.pagedItems = [];
        if (!data.IsError && data.DataObject != null) {
          _this.releaseData = data.DataObject;
          _this.releaseData.forEach((element) => {
            const customers = element.Customers ? element.Customers.map((c:any, index: number) => `${index+1}. ${c.Name}`) : [];
            const toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
            element.CustomerTooltip = toolip;
            if (_this.IsShowDeleted) {
              _this.pagedItems.push(element);
            } else {
              if (element.IsDeleted == false) {
                _this.pagedItems.push(element);
              }
            }
          });
        } else {
          _this.releaseData = null;
        }
      }),
      catchError((error) => {
        _this.errorMessage = error;
        return of(null); // Keep forkJoin alive even if one fails
      })
    );

    // 3. Define the second API call stream with its side-effects
    const getIsAllowed$ = this.productReleaseService.getIsAllowedToAddReleaseByProductId(ProductId).pipe(
      take(1),
      tap((data) => {
        if (!data.IsError && data.DataObject != null) {
          _this.IsAllowedToAdd = false;
        } else {
          _this.IsAllowedToAdd = true;
        }
      }),
      catchError((error) => {
        _this.errorMessage = error;
        return of(null); // Keep forkJoin alive even if one fails
      })
    );

    // 4. Return combined observable that completes only when both requests finish
    return forkJoin([getRelease$, getIsAllowed$]);
  }
  //#endregion

  //#region  getUserRights to visible button true false
  getUserRights(UserId, ProductId) {
    this.userservice.getUserRightsById(UserId, ProductId).subscribe(
      (Data) => {
        if (Data != "") {
          this.IsAdd = Data[0].IsAdd;
          this.IsEdit = Data[0].IsEdit;
          this.IsProductionRights = Data[0].IsActiveInactive; // IsDelete means Active/Inactive Release
          this.IsApprove = Data[0].IsApproveReject;
        }
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }
  //#endregion

  //#region  Click: Active Release
  ActiveRelease(row) {
    // In SCAL360 Case DBVersion Based Active Release
    if (this.IsProductCodeVisble) {
      this.productReleaseService
        .getProductionRelease(this.ProductId)
        .subscribe((Data) => {
          if (
            Data.DataObject != null &&
            row.DBVersion != "" &&
            Number(Data.DataObject.DBVersion) > Number(row.DBVersion)
          ) {
            let confirmdialog: MdDialogRef<PageLayoutConfirmDialogComponent> =
              this.dialog.open(PageLayoutConfirmDialogComponent, {
                data: {
                  ProductReleaseNo: row.ProductReleaseNo,
                  Status: "DBVersionMSG",
                },
                disableClose: true,
              });
            confirmdialog.afterClosed().subscribe((_result) => {
              this.getProductReleaseList(this.ProductId);
            });
          } else {
            this.OpenConfirmDialog(row);
          }
        });
    } else {
      // In Other Product No Condition Checked
      this.OpenConfirmDialog(row);
    }
  }

  // #region  Code Complexity Resolved [Create a Function OpenConfirmDialog]
  OpenConfirmDialog(row) {

    const isPilotCustomReleaseSupported = this.ProductCode in PilotCustomSupportedProductCodes && 
                      this.SubType in PilotCustomSupportedSubTypes &&
                      this.Variant in PilotCustomSupportedVariants;

    let activateReleaseDialog: MdDialogRef<ActivateReleaseComponent | PageLayoutRevertReleaseComponent>;
    
    const data = {
      ProductReleaseId: row.ProductReleaseId,
      ProductId: this.ProductId,
      ParentProductId: this.ParentProductId,
      ProductReleaseNo: row.ProductReleaseNo,
      ProductName: this.ProductName,
      SubProductName: this.SubProductName,
      ProductCode:this.ProductCode,
      Status: 3,
      IsSTPPerformed: row.IsSTPPerformed,
      releaseList: this.pagedItems
    }

    if(isPilotCustomReleaseSupported){
      activateReleaseDialog = this.dialog.open(ActivateReleaseComponent, {
        width: "35%",
        data: data,
        disableClose: true,
      });
    }
    else{
      activateReleaseDialog = this.dialog.open(PageLayoutRevertReleaseComponent, {
        data: data,
        disableClose: true,
      }); // Release Management Active Status : 3
    }

    activateReleaseDialog.afterClosed().subscribe((result) => {
      this.getProductReleaseList_Observable(this.ProductId).subscribe(() => {
        this.appLoaderService.close();
        if(isPilotCustomReleaseSupported){
          if(result){
            this.SendEmail(row, result.SelectedReleaseType);
            this.SendEmailToSyncItClientAdmins(row, result);
          }
        }
        else{
          if (typeof result === "object") {
            this.SendEmail(row, ProductReleaseStatus.STPStart);
          } else if(result == true) {
            this.SendEmail(row, ProductReleaseStatus.ProductionRelease);
          }
        }
      });
    });
  }
  //#endregion
  //#endregion

  //#region  Click: Approve Release
  ApproveRelease(row) {
    let approveDialog: MdDialogRef<PageLayoutRevertReleaseComponent> =
      this.dialog.open(PageLayoutRevertReleaseComponent, {
        data: {
          ProductReleaseId: row.ProductReleaseId,
          ProductId: this.ProductId,
          ProductReleaseNo: row.ProductReleaseNo,
          Status: 2,
          IsSTPPerformed: row.IsSTPPerformed,
        },
        disableClose: true,
      }); // Release Management Approve Status : 2
    approveDialog.afterClosed().subscribe((result) => {
      this.getProductReleaseList(this.ProductId);
      if (result) {
        this.SendEmail(row, ProductReleaseStatus.QARelease);
      }
    });
  }
  //#endregion

  // #region  Click: Reject Release
  RejectRelease(row) {
    let rejestdialog: MdDialogRef<PageLayoutRevertReleaseComponent> =
      this.dialog.open(PageLayoutRevertReleaseComponent, {
        data: {
          ProductReleaseId: row.ProductReleaseId,
          ProductId: this.ProductId,
          ProductReleaseNo: row.ProductReleaseNo,
          Status: -1,
          IsSTPPerformed: row.IsSTPPerformed,
        },
        disableClose: true,
      }); // Release Management Delete Status : 2
    rejestdialog.afterClosed().subscribe((result) => {
      this.getProductReleaseList(this.ProductId);
      if (result) {
        this.SendEmail(row, -1);
      }
    });
  }
  //#endregion

  //#region ViewReleaseHistory
  ViewHistory(row) {
    let historyDialog: MdDialogRef<PageLayoutRevisionHistoryComponent> =
      this.dialog.open(PageLayoutRevisionHistoryComponent, {
        height: "50%",
        width: "60%",
        data: {
          ProductReleaseId: row.ProductReleaseId,
          ProductReleaseNo: row.ProductReleaseNo,
          ProductName: this.ProductName,
          SubProductName: this.SubProductName,
        },
      });
    historyDialog.afterClosed().subscribe((_result) => {
      //this.getProductReleaseList(this.ProductId);
    });
  }
  //#endregion

  //Region Click: STPStart
  STPStart(row) {
    let STPStart: MdDialogRef<PageLayoutRevertReleaseComponent> =
      this.dialog.open(PageLayoutRevertReleaseComponent, {
        data: {
          ProductReleaseId: row.ProductReleaseId,
          ProductId: this.ProductId,
          ProductReleaseNo: row.ProductReleaseNo,
          Status: 1,
          IsSTPPerformed: row.IsSTPPerformed,
        },
        disableClose: true,
      }); // Release Management STPStart Status : 1
    STPStart.afterClosed().subscribe((result) => {
      this.getProductReleaseList(this.ProductId);
      if (result) {
        this.SendEmail(row, ProductReleaseStatus.STPStart);
      }
    });
  }
  //#endregion

  ChangeReleaseType(row){
    let changeReleaseTypeDialog: MdDialogRef<ChangeReleaseTypeComponent> =
      this.dialog.open(ChangeReleaseTypeComponent, {
        width: "40%",
        data: {
          ProductReleaseId: row.ProductReleaseId,
          ProductId: this.ProductId,
          ProductReleaseNo: row.ProductReleaseNo,
          Status: row.Status,
          IsSTPPerformed: row.IsSTPPerformed,
          releaseList: this.pagedItems
        },
        disableClose: true,
      });
    changeReleaseTypeDialog.afterClosed().subscribe((result) => {
      this.getProductReleaseList_Observable(this.ProductId).subscribe(() => {
        this.appLoaderService.close();
        if (result) {
          this.SendEmail(row, result.SelectedReleaseType);
          this.SendEmailToSyncItClientAdmins(row, result);
        }
      })
    });
  }
  //#region DownloadFile
  DownloadFile(row) {
    this.appLoaderService.open();
    this.productReleaseService
      .DownloadReleaseFile(row.ProductReleaseId)
      .subscribe(
        (result: any) => {
          switch (result.type) {
            case HttpEventType.DownloadProgress:
              const percentage = Math.round(
                (result.loaded / result.total) * 100
              );
              this.appLoaderService.ChangeLoaderTitle("Downloading File");
              this.appLoaderService.ChangePercentage(percentage + "%");
              break;
            case HttpEventType.Response:
              const downloadedFile = new Blob([result.body], {
                type: result.body.type,
              });
              const a = document.createElement("a");
              a.setAttribute("style", "display:none;");
              document.body.appendChild(a);
              a.download = row.FileName;
              a.href = URL.createObjectURL(downloadedFile);
              a.target = "_blank";
              a.click();
              document.body.removeChild(a);
              this.appLoaderService.close();
              break;
          }
        },
        (_error) => {
          this.appLoaderService.close();
        }
      );
  }
  //#endregion

  //#region  SendEmail Function
  SendEmail(ProductReleaseInfo, ReleaseStatus) {
    let model = {
      ProductName: this.ProductName,
      SubProductName: this.SubProductName,
      ProductCode: this.ProductCode,
      Variant: this.Variant,
      SubType: this.SubType,
      TabOrder: this.TabOrder,
      ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
      ReleaseDate: new Date(),
      UpdatedBy: localStorage.getItem("Name"),
      ProductId: this.ParentProductId,
      ReleaseStatus: ReleaseStatus,
    };
    this.productReleaseService.SendEmail(model).subscribe(
      (Data) => {
        if (Data.IsError) {
          swal.fire("Error", Data.Error, "error");
        }
      },
      (error) => {
        this.errorMessage = error;
      }
    );
  }
  
  SendEmailToSyncItClientAdmins(ProductReleaseInfo, statusChangeInfo) {
    if(statusChangeInfo.isNotifySyncItClientAdmin){
      let model = {
        ProductId: this.ProductId,
        ProductName: this.ProductName,
        SubProductName: this.SubProductName,
        ProductCode: this.ProductCode,
        SubType: this.SubType,
        Variant: this.Variant,
        ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
        ReleaseDate: new Date(),
        ReleaseStatus: statusChangeInfo.SelectedReleaseType,
        CustomerIds: statusChangeInfo.customers
      };
      this.productReleaseService.SendEmailToSyncItClientAdmins(model).subscribe(
        (Data) => {
          if (Data.IsError) {
            swal.fire("Error", Data.Error, "error");
          }
        },
        (error) => {
          this.errorMessage = error;
        }
      );
    }
  }
  //#endregion
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/product-list-tab-child-list/product-release-tab-list.component.ts